import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { EMPTY, forkJoin } from 'rxjs';
import { AlertService } from 'src/app/common/alert.service';
import { DataService } from 'src/app/common/data.service';
import { ProgressService } from 'src/app/common/progress.service';
import { IExcelUpload, IStatus } from 'src/app/model/bp-record';
import * as moment from 'moment';
import { MessageService } from 'primeng/api';
import { IAuditTrail } from '../../model/bp-record';

@Component({
  selector: 'app-upload-excel-data',
  templateUrl: './upload-excel-data.component.html',
  styleUrls: ['./upload-excel-data.component.css']
})
export class UploadExcelDataComponent implements OnInit {
  uploadedFile: File;
  FailedFile: File;
  AttachmentID: number;
  auditCols: any[];
  Excelfile: any;
  FaildExcelfile: any;
  ExcelUploadList: Array<IExcelUpload> = [];
  cols: any[];
  auditTrailList: Array<IAuditTrail> = [];
  first: number = 0;
  loading: boolean = false;
  confirmtype: string = "";
  showReupload = false;
  moment: any = moment;
  displayAuditTrail: boolean = false;
  ReqDatefrom: any = undefined;
  ReqDateTo: any = undefined;

  constructor(private alertService: AlertService,
    private UploadExcelService: DataService,
    private progressService: ProgressService,
    private _fb: FormBuilder,
    private messageService: MessageService,
    private excelUploadService: DataService) { }

  paginate(event) {
    this.first = event.first;
  }

  StatusList: Array<IStatus> = [
    {
      Id: 0,
      Name: '-- select --',
    },
    {
      Id: 1,
      Name: 'Pending',
    },
    {
      Id: 2,
      Name: 'InProcess',
    },
    {
      Id: 3,
      Name: 'Completed',
    },
    {
      Id: 4,
      Name: 'Fail',
    }
  ];


  ngOnInit() {
    this.cols = [
      { field: 'AttachmentID', header: 'ID' },
      { field: 'AttachmentName', header: 'Attachment Name' },
      { field: 'UploadedBy', header: 'Uploaded By' },
      { field: 'UploadedOn', header: 'Uploaded On' },
      { field: 'Status', header: 'Status' },
      { field: 'button', header: '', width: '150px' }
    ];

    this.auditCols = [
      { field: 'Name', header: 'Name', hidden: false },
      { field: 'CreatedOn', header: 'Updated On', hidden: false, width: '100px' },
      { field: 'FieldName', header: 'Field Name', hidden: false, width: '150px' },
      { field: 'OldValue', header: 'Old Value', hidden: false, width: '150px' },
      { field: 'NewValue', header: 'New Value', hidden: false, width: '100px' },
      { field: 'Action', header: 'Action', hidden: false, width: '200px' },
    ];

    this.loadData(false);
  }

  /// load and filtering Excel records 
  loadData(_isFilter: boolean) {
    //From Date convert to date string
    let ReqDate = this.filterForm.controls['FromDate'].value;
    if (ReqDate != undefined && ReqDate != '' && ReqDate != null) {
      ReqDate = new Date(ReqDate);
    }
    this.ReqDatefrom = (ReqDate == undefined || ReqDate == '' || ReqDate == null) ? '' : ReqDate.toDateString();

    //To Date convert to date string
    let ReqToDate = this.filterForm.controls['ToDate'].value;
    if (ReqToDate != undefined && ReqToDate != '' && ReqToDate != null) {
      ReqToDate = new Date(ReqToDate);
    }
    this.ReqDateTo = (ReqToDate == undefined || ReqToDate == '' || ReqToDate == null) ? '' : ReqToDate.toDateString();

    this.loading = true;
    let filterObj: any = {};

    filterObj = {
      UploadedBy: this.f.UploadedBy.value ? this.f.UploadedBy.value : null,
      FromDate: this.ReqDatefrom, //this.f.FromDate.value ? this.f.FromDate.value : null,
      ToDate: this.ReqDateTo, //this.f.ToDate.value ? this.f.ToDate.value : null,
      Status: this.f.Status.value ? this.f.Status.value.Id : 0
    }

    this.excelUploadService.PostData('GetExcelUploadedData', filterObj).subscribe(
      (data: any) => {

        this.ExcelUploadList = data;
        this.loading = false;
        this.showReupload = false;
      }, _error => {

        this.loading = false;
        this.showReupload = false;
      }
    );
  }

  filterForm: FormGroup = this._fb.group({
    UploadedBy: [''],
    FromDate: [''],
    ToDate: [''],
    Status: []
  });

  resetAll() {
    this.filterForm.reset();
    this.loadData(false);
  }

  submitRecord() {
    if (this.uploadedFile == undefined || this.uploadedFile == null) {
      this.alertService.notify('warn', 'warning', 'Please choose file then upload.');
      return;
    }

    this.Excelfile = document.getElementById("Excelfile");
    const formDataExcelFile = new FormData();
    if (this.Excelfile.files.length > 0) {
      formDataExcelFile.append(this.Excelfile.files[0].name, this.Excelfile.files[0]);

      this.UploadExcelService.PostData('UploadExcelFile/', formDataExcelFile).subscribe((data: any) => {
        if (data == 1) {
          this.progressService.ChangeProgressStatus(false);
          this.alertService.notify('success', 'Success', 'Excel Uploaded successfully');
          (<HTMLInputElement>document.getElementById("Excelfile")).value = null;
          this.loadData(true);
        }
      },
        error => {
          alert(error.statusText);
          this.progressService.ChangeProgressStatus(false);
        }

      )
    }
  }

  reSubmitRecord(attachmentID: number) {
    if (this.FailedFile == undefined || this.FailedFile == null) {
      this.alertService.notify('warn', 'warning', 'Please choose file then upload.');
      return;
    }

    this.FaildExcelfile = document.getElementById("FailedExcelfile_" + attachmentID);
    const formDataExcelFile = new FormData();
    if (this.FaildExcelfile.files.length > 0) {
      formDataExcelFile.append(this.FaildExcelfile.files[0].name, this.FaildExcelfile.files[0]);

      this.UploadExcelService.PostData('UploadFailedExcelFile/' + attachmentID, formDataExcelFile).subscribe((data: any) => {
        if (data == 1) {
          this.progressService.ChangeProgressStatus(false);
          this.alertService.notify('success', 'Success', 'Excel Uploaded successfully');
          this.FaildExcelfile.value = null;
          this.loadData(true);
        }
      },
        error => {
          alert(error.statusText);
          this.FaildExcelfile.value = null;
          this.progressService.ChangeProgressStatus(false);
        }

      )
    }
  }

  onfilechange(event: any) {
    this.uploadedFile = event.target.files[0];
    const fileExtenstion = this.uploadedFile.name.substring(this.uploadedFile.name.lastIndexOf('.') + 1);
    if (fileExtenstion != 'xls' && fileExtenstion != 'xlsx' && fileExtenstion != 'xlsb') {
      this.alertService.notify('warn', 'Warn', 'Unsupported File,Only Excel allowed. Please try again!');
      event.target.value = "";
      return;
    }
  }

  onFailedfilechange(event: any, attachmentID: number) {
    this.AttachmentID = attachmentID;
    this.FaildExcelfile = document.getElementById("FailedExcelfile_" + attachmentID);
    this.FailedFile = event.target.files[0];
    const fileExtenstion = this.FailedFile.name.substring(this.FailedFile.name.lastIndexOf('.') + 1);
    if (fileExtenstion != 'xls' && fileExtenstion != 'xlsx' && fileExtenstion != 'xlsb') {
      this.alertService.notify('warn', 'Warn', 'Unsupported File,Only Excel allowed. Please try again!');
      event.target.value = "";
      this.FailedFile = null;
      this.FaildExcelfile.value = null;
      return;
    }

    this.showConfirm('reupload');
  }

  showConfirm(_confirmtype: string) {
    this.confirmtype = _confirmtype;
    let confirmMessage: string = "";

    if (this.confirmtype == "reupload") {

      confirmMessage = "Are you sure you want to Upload?";
    }

    this.messageService.clear();
    this.messageService.add({ key: 'c', sticky: true, severity: 'warn', summary: confirmMessage, detail: '' });

  }

  onConfirm(confirmtype: string) {
    this.messageService.clear('c');
    if (this.confirmtype == "reupload") {
      alert(this.AttachmentID);
      this.reSubmitRecord(this.AttachmentID);
    }
  }

  onReject() {
    this.messageService.clear('c');
    this.FailedFile = null;
    this.FaildExcelfile.value = '';
  }

  get f() {
    return this.filterForm.controls;
  }

  onShowAuditTrail() {
    this.displayAuditTrail = false;
    this.UploadExcelService.GetData('GetAllAuditTrailByID/' + '0' + '/uploadexcelfileBO').subscribe(
      (data: any) => {
        this.auditTrailList = data;
        this.displayAuditTrail = true;
        this.progressService.ChangeProgressStatus(false);
      });
  };

}
